import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import "./EventCardSmall.css";

const EventCardSmall = ({ event }) => {
  const PastEventDistrict = event.venueMasterDTO?.district || "";
  const PastEventState = event.venueMasterDTO?.state || "";
  const PastEventPincode = event.venueMasterDTO?.pincode || "";
  const offlineFlag = event.offline;
  const isOffline =
    offlineFlag === true ||
    offlineFlag === "true" ||
    (typeof offlineFlag === "string" &&
      offlineFlag.toLowerCase() === "offline") ||
    Number(offlineFlag) === 1 ||
    (event.type && event.type.toLowerCase() === "offline");
  const isOnline = !isOffline;

  return (
    <div className="event-card-small">
      <div className="event-card-small-header">
        <span className="event-date">{event.date}</span>
        <span className="event-separator">|</span>
        <span className="event-time">{event.time}</span>
      </div>

      <div className="event-card-small-body">
        <h4 className="event-small-title">{event.title}</h4>
        <p className="event-trainer-info">
          By {event.trainer} in {event.language}
        </p>
      </div>

      <div className="event-small-divider"></div>

      <div className="event-card-small-footer">
        {isOffline && (
          <div className="event-location-badge">
            <FmdGoodOutlinedIcon className="type-icon" fontSize="md" />
            <span>
              {PastEventDistrict && PastEventState
                ? `${PastEventState}, ${PastEventDistrict}  - ${PastEventPincode}`
                : "Online Webinar"}
            </span>
          </div>
        )}
        {isOnline && (
          <div className="event-location-badge online">
            <DesktopWindowsOutlinedIcon className="type-icon" fontSize="md" />
            <span>{event.place || "Online Webinar"}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventCardSmall;
